import { render } from "./tag-filters.vue?vue&type=template&id=250b47f9&lang=pug"
import script from "./tag-filters.vue?vue&type=script&lang=js"
export * from "./tag-filters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__